import { Box } from '@betterment/samba-react';
import { useLoaderData } from 'react-router-dom';

import AvailableRewardsPage from './AvailableRewardsPage';
import Header from './Header';
import { ReferAFriendProvider } from './ReferAFriendProvider';
import TabNavigation from './TabNavigation';

import { ApplicationLayout } from '../../Shared/layout/ApplicationLayout';
import { ActiveSenderOfferName, Referral, SenderOfferFulfillment } from '../data';

export interface ReferAFriendPageLoaderData {
  firstName: string;
  referralKey: string;
  senderOfferName: ActiveSenderOfferName;
  referralFulfillments: number;
  senderOfferFulfillments: SenderOfferFulfillment[];
  maxReferralRewardCount: number;
  hasMaximumInvestingReferrals: boolean;
  referralInvites: Referral[];
}

const ReferAFriendPage = () => {
  const {
    firstName,
    referralKey,
    senderOfferName,
    referralFulfillments,
    senderOfferFulfillments,
    maxReferralRewardCount,
    hasMaximumInvestingReferrals,
    referralInvites,
  } = useLoaderData<ReferAFriendPageLoaderData>();

  return (
    <ApplicationLayout pageTitle={`${firstName}'s Referrals`}>
      <ReferAFriendProvider
        referralKey={referralKey}
        senderOfferName={senderOfferName}
        senderOfferFulfillments={senderOfferFulfillments}
        hasMaximumInvestingReferrals={hasMaximumInvestingReferrals}
        referralInvites={referralInvites}
        referralFulfillments={referralFulfillments}
        maxReferralRewardCount={maxReferralRewardCount}
      >
        <ApplicationLayout.Header>
          <Box css={{ px: { base: 'space.200', md: 'space.0' } }}>
            <Header />
            <TabNavigation />
          </Box>
        </ApplicationLayout.Header>
        <ApplicationLayout.Content>
          <Box css={{ bg: 'background' }}>
            <AvailableRewardsPage />
          </Box>
        </ApplicationLayout.Content>
      </ReferAFriendProvider>
    </ApplicationLayout>
  );
};

export default ReferAFriendPage;
